function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import Login from '../auth/Login.react';
import ResetPassword from '../auth/ResetPassword.react';
import ForgotPassword from '../auth/ForgotPassword.react';
var Preload = function Preload() {
  var booted = useSelector(function (s) {
    return s.app.booted;
  });
  var isLoggedIn = useSelector(function (s) {
    return s.app.isLoggedIn;
  });
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    disableToggle = _useState4[0],
    setDisableToggle = _useState4[1];
  useEffect(function () {
    setTimeout(function () {
      setDisableToggle(false);
    }, 500);
  }, []);
  var toggle = function toggle() {
    if (disableToggle) return;
    if (isLoggedIn) {
      $('.preload').css({
        opacity: 0
      });
      setTimeout(function () {
        setVisible(false);
      }, 1000);
    } else {
      setVisible(true);
    }
  };
  useEffect(toggle, [booted, disableToggle, isLoggedIn]);
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "preload"
  }, disableToggle && /*#__PURE__*/React.createElement("div", {
    className: "preload__loader"
  }, "LOADING..."), /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    element: /*#__PURE__*/React.createElement(Login, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/reset-password",
    element: /*#__PURE__*/React.createElement(ResetPassword, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/forgot-password",
    element: /*#__PURE__*/React.createElement(ForgotPassword, null)
  })));
};
export default Preload;